
























import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';


@Component
export default class ImgView extends Vue {
  @Prop({ default: null })
  public canvasArr?: HTMLCanvasElement[];

  @Prop({ default: null })
  public imgArr?: string[];
  
  // start from 1
  @Prop({ default: 1})
  public startPageNum!: number;

  public defaultRenderNumPages: number = 10;

  public imgs: string[] = [];

  // public renderNumPages: number = 0;

  get renderNumPages() {
    return Math.min(this.defaultRenderNumPages, this.imgs.length || 0);
  }

  @Watch('canvasArr', { immediate: true, deep: true })
  public updatePdf(newVal, oldVal) {
    // window.alert(newVal == this.canvasArr)
    // console.log(this.canvasArr);
    if (this.canvasArr && this.canvasArr.length) {
      this.imgs = this.canvasArr!.map((v) => v.toDataURL('image/png', 1.0));
      // console.log(this.renderNumPages);
      // this.renderNumPages = Math.min(this.defaultRenderNumPages, this.imgs.length || 0);
      // console.log(this.renderNumPages);
      // console.log(this.imgs);
    }
  }

  @Watch('imgArr', { immediate: true, deep: true })
  public updateImg(newVal) {
    if (this.imgArr && this.imgArr.length) {
      this.imgs = this.imgArr;
    }
  }

  @Emit('clickLeftTopBtn')
  public clickLeftTopBtn(i: number) {
    console.log(i);
    return i;
  }
}
